import React, { useEffect, useState } from "react"
import "./add_item_picking_return.css";
import { Button, Form, Input, Modal, Space } from "antd";
import { DataType } from "../../components/hoc_picking_list_return";
import LocationRackPickingReturn, { RackLocationRecord } from "./location_rack_picking_return";

interface AddItemPickingReturnProps {
    initialData: DataType | null;
    onBrowse: () => void;
    pickingListNo: string | null;
    warehouse?: string;
    warehouseCode?: string;
    onUpdate: (values: { return_qty: number }) => void;
    onAdd: (values: { return_qty: number }) => void;
    isEditing: boolean;
    isProgress?: boolean;
}

const AddItemPickingReturn: React.FC<AddItemPickingReturnProps> = ({
    initialData,
    onBrowse,
    pickingListNo,
    warehouse,
    warehouseCode,
    onUpdate,
    onAdd,
    isEditing,
    isProgress = false
}) => {
    const [form] = Form.useForm();
    const [isLocationModalVisible, setIsLocationModalVisible] = useState(false);
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    useEffect(() => {
        if (initialData) {
            form.setFieldsValue({
                item_code: initialData.item_code,
                location: initialData.location_rack,
                uom: initialData.uom,
                available_qty: initialData.available_qty,
                demand_qty: initialData.demand_qty,
                supply_qty: initialData.supply_qty,
                pick_qty: initialData.pick_qty,
                pack_qty: initialData.packing_qty,
                return_qty: initialData.return_qty || '',
                return_qty_db: (initialData as any).return_qty_db || 0,
            });
        } else {
            form.resetFields();
        }
    }, [initialData, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            const returnValues = { return_qty: Number(values.return_qty) || 0 };
            if (isEditing) {
                onUpdate(returnValues);
            } else {
                onAdd(returnValues);
            }
        }).catch(info => {
            console.log('Validate Failed:', info);
        });
    };


    return (

        <div id="ilmf" style={transformStyle}>
            <div className="gjs-grid-row" id="i8cv">
                <div className="gjs-grid-column" id="ipzz">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Item Code"
                            name="item_code"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <div style={{ display: "flex", gap: "1px", alignItems: "center" }}>
                                <Form.Item
                                    name="item_code"
                                    style={{
                                        width: '300px',
                                        marginRight: '8px',
                                        marginBottom: 0
                                    }}>
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="browser_item_picking_return"
                                    onClick={onBrowse}
                                    disabled={!pickingListNo || isEditing || isProgress}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{
                                                width: "40px",
                                                height: "20px",
                                            }}
                                        >
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    }
                                />
                            </div>
                        </Form.Item>
                        <Form.Item label="Location" style={{ marginBottom: "5px" }}>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Form.Item name="location" noStyle style={{ width: "85%" }}>
                                    <Input placeholder="" style={{ width: "90%" }} readOnly />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="location_rack_picking_return"
                                    onClick={() => setIsLocationModalVisible(true)}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}>
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    }
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="UOM"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Demand Qty"
                            name="demand_qty"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Supply Qty"
                            name="supply_qty"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Return Qty"
                            name="return_qty"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        const supplyQty = Number(getFieldValue('supply_qty') || 0);
                                        if (!value || Number(value) <= supplyQty) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(`Melebihi batas maksimal pengembalian (${supplyQty})`));
                                    },
                                }),
                            ]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                    </Form>
                    <Space>
                        <Button
                            type="primary"
                            id="add_item_picking"
                            style={{
                                height: "40px",
                                width: "105px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                            disabled={isProgress}
                            icon={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    style={{ width: "22px", height: "22px" }}
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            }
                            onClick={handleOk}
                        >
                            {isEditing ? 'Edit' : 'OK'}
                        </Button>
                    </Space>
                    <Modal
                        title="Browse Location Rack"
                        open={isLocationModalVisible}
                        onCancel={() => setIsLocationModalVisible(false)}
                        width="600px"
                        footer={null}
                        destroyOnClose
                    >
                        <LocationRackPickingReturn
                            warehouse={warehouse}
                            warehouseCode={warehouseCode}
                            itemCode={form.getFieldValue('item_code') || initialData?.item_code}
                            onSelectLocation={(record: RackLocationRecord) => {
                                form.setFieldsValue({ location: record.code_rack });
                                setIsLocationModalVisible(false);
                            }}
                        />
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default AddItemPickingReturn;
